import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Logo from '../common/Logo';
import Button from '../common/Button';

const navigation = [
  { name: 'Strona główna', path: '/' },
  { name: 'Cennik', path: '/services' },
  { name: 'Galeria', path: '/gallery' },
  { name: 'Lokalizacja', path: '/location' },
  { name: 'Kontakt', path: '/contact' }
];

const NavigationLink = ({ path, children, isActive }) => (
  <Link
    to={path}
    className={`
      px-4 py-2 text-sm rounded-full transition-all duration-300
      ${isActive 
        ? 'text-white bg-primary-600' 
        : 'text-gray-200 hover:text-white hover:bg-white/10'
      }
    `}
  >
    {children}
  </Link>
);

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActivePath = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav
      className={`
        fixed w-full z-50 transition-all duration-300
        ${isScrolled 
          ? 'bg-black/80 backdrop-blur-md py-2' 
          : 'bg-transparent py-4'
        }
      `}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Logo className="text-white" />

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-2">
            {navigation.map((item) => (
              <NavigationLink
                key={item.name}
                path={item.path}
                isActive={isActivePath(item.path)}
              >
                {item.name}
              </NavigationLink>
            ))}
            {user && (
              <Button
                onClick={handleLogout}
                className="ml-4"
                variant="secondary"
              >
                Wyloguj
              </Button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-white rounded-lg hover:bg-white/10"
            aria-label={isMobileMenuOpen ? 'Zamknij menu' : 'Otwórz menu'}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 bg-black/95 rounded-lg">
            <div className="flex flex-col space-y-2 p-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`
                    px-4 py-2 rounded-lg text-sm
                    ${isActivePath(item.path)
                      ? 'bg-primary-600 text-white'
                      : 'text-gray-200 hover:bg-white/10'
                    }
                  `}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              {user && (
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 text-left text-sm text-gray-200 hover:bg-white/10 rounded-lg"
                >
                  Wyloguj
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
